import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
import "core-js/modules/es6.function.name";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapMutations } from 'vuex';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/chevron-bottom-doodle.svg';
import CategoryFacetItem from '~/components/molecules/Category/CategoryFacetItem.vue';
export default {
  name: 'CategoryCheckboxFilter',
  components: {
    CategoryFacetItem: CategoryFacetItem
  },
  props: {
    selected: {
      type: Array,
      required: true
    },
    filter: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      active: false,
      showAll: false,
      maxItems: 6,
      checkedFacets: []
    };
  },
  computed: {
    facets: function facets() {
      var facets = this.filter.facets.filter(function (e) {
        return e.label;
      });
      return this.showAll || this.isColor ? facets : facets.slice(0, 16);
    },
    isColor: function isColor() {
      return ['color', 'segmentations.colors.label'].includes(this.filter.name);
    }
  },
  watch: {
    filter: function filter() {
      this.showAll = false;
      this.checkedFacets = this.facets ? this.facets.filter(function (f) {
        return f.selected;
      }).map(function (f) {
        return f.key;
      }) : [];
    }
  },
  mounted: function mounted() {
    this.checkedFacets = this.facets ? this.facets.filter(function (f) {
      return f.selected;
    }).map(function (f) {
      return f.key;
    }) : [];
  },
  methods: _objectSpread({}, mapMutations({
    filterBy: 'pageActions/FILTER_BY'
  }), {
    selectedFacet: function selectedFacet(facet) {
      return this.selected.map(function (e) {
        return e.facet;
      }).includes(facet);
    },
    tracking: function tracking(facet) {
      var filter = "".concat(this.filter.label.charAt(0).toUpperCase()).concat(this.filter.label.slice(1));
      return {
        data: {
          event_category: window.tc_vars.env_template === 'listproduct_keyword' ? 'Search Page' : 'Categorie',
          event_action: "Filtre_".concat(filter, "_").concat(facet.label),
          event_label: "".concat(window.tc_vars.page_cat1, "_").concat(window.tc_vars.page_cat3)
        }
      };
    },
    applyCheckboxChanges: function applyCheckboxChanges(facet, evt) {
      this.filterBy({
        filter: this.filter.name,
        facet: facet.key
      });
      this.$root.$emit('generic-tracking', evt, this.tracking(facet));
      if (!this.checkedFacets.includes(facet.key)) this.checkedFacets.push(facet.key);else this.checkedFacets = this.checkedFacets.filter(function (e) {
        return e !== facet.key;
      });
    },
    seeMore: function seeMore() {
      this.showAll = true;
    }
  })
};